import * as React from 'react';
import { IConfigurationFormatted } from '../../types/project';
import { ConfigurationsMobile } from '../../components/Configurations';
import { useSelector } from 'react-redux';
import { selectConfigurations, selectProjectName } from '../../selectors';
import { useEventCallback } from '@cian/react-utils';
import { ConfigurationModal } from '../../components/ConfigurationModal';
import { CallButtonContainer } from '../CallButtonContainer';

export const ConfigurationsContainerMobile = () => {
  const projectName = useSelector(selectProjectName);
  const configurations = useSelector(selectConfigurations);
  const [selectedConfiguration, selectConfiguration] = React.useState<IConfigurationFormatted | null>(null);

  const handleCloseModal = useEventCallback(() => {
    selectConfiguration(null);
  });

  if (!configurations.length) {
    return null;
  }

  return (
    <>
      <ConfigurationsMobile configurations={configurations} onSelectConfiguration={selectConfiguration} />
      <ConfigurationModal
        {...selectedConfiguration}
        phoneButton={<CallButtonContainer size="L" fullWidth />}
        projectName={projectName}
        open={!!selectedConfiguration}
        onClose={handleCloseModal}
      />
    </>
  );
};
